// extracted by mini-css-extract-plugin
export default {"optionSeparator":"MerchantPurposeForm_optionSeparator__B-ui0"};